// Exact BFF Classic 1v1 stadium captured in replay stats.
// Source replay stats: server/data/stats/b9af29a1d6ee7243349172579f6f351c.json
// This is plain stadium data; simulation uses the native HaxBall classes.
export const bffClassic = {
  "name": "BFF Classic v3",
  "height": 230,
  "width": 480,
  "maxViewWidth": 0,
  "cameraFollow": "ball",
  "spawnDistance": 200,
  "kickOffReset": "partial",
  "bg": {
    "type": "none",
    "width": 400,
    "height": 200,
    "kickOffRadius": 60,
    "cornerRadius": 0,
    "color": "34414B",
    "goalLine": 0
  },
  "canBeStored": true,
  "redSpawnPoints": [],
  "blueSpawnPoints": [],
  "playerPhysics": {
    "bCoef": 0,
    "invMass": 0.5,
    "damping": 0.96,
    "acceleration": 0.11,
    "kickingAcceleration": 0.083,
    "kickingDamping": 0.96,
    "kickStrength": 4.2,
    "cGroup": [],
    "gravity": [
      0,
      0
    ],
    "radius": 15,
    "kickback": 0
  },
  "segments": [
    {
      "v0": 5,
      "v1": 6,
      "bias": 0,
      "bCoef": 0,
      "curve": 0,
      "vis": true,
      "cMask": [],
      "cGroup": [],
      "color": "ABC2D5"
    },
    {
      "v0": 4,
      "v1": 7,
      "bias": 0,
      "bCoef": 0,
      "curve": 0,
      "vis": true,
      "cMask": [],
      "cGroup": [],
      "color": "ABC2D5"
    },
    {
      "v0": 6,
      "v1": 13,
      "bias": 0,
      "bCoef": 0.1,
      "curve": 0,
      "vis": false,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "redKO",
        "blueKO"
      ],
      "color": "000000"
    },
    {
      "v0": 7,
      "v1": 12,
      "bias": 0,
      "bCoef": 0.1,
      "curve": 0,
      "vis": false,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "redKO",
        "blueKO"
      ],
      "color": "000000"
    },
    {
      "v0": 6,
      "v1": 7,
      "bias": 0,
      "bCoef": 0.1,
      "curve": 180,
      "vis": true,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "redKO"
      ],
      "color": "D9A472"
    },
    {
      "v0": 7,
      "v1": 6,
      "bias": 0,
      "bCoef": 0.1,
      "curve": 180,
      "vis": true,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "blueKO"
      ],
      "color": "D9A472"
    },
    {
      "v0": 18,
      "v1": 19,
      "bias": 0,
      "bCoef": 0,
      "curve": 180,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "626262"
    },
    {
      "v0": 19,
      "v1": 18,
      "bias": 0,
      "bCoef": 0,
      "curve": 180,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "626262"
    },
    {
      "v0": 21,
      "v1": 20,
      "bias": 0,
      "bCoef": 0,
      "curve": 150,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "626262"
    },
    {
      "v0": 22,
      "v1": 23,
      "bias": 0,
      "bCoef": 0,
      "curve": 150,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "626262"
    },
    {
      "v0": 10,
      "v1": 14,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "6666FF"
    },
    {
      "v0": 28,
      "v1": 29,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "6666FF"
    },
    {
      "v0": 15,
      "v1": 11,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "6666FF"
    },
    {
      "v0": 8,
      "v1": 17,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "FF6666"
    },
    {
      "v0": 31,
      "v1": 30,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "FF6666"
    },
    {
      "v0": 16,
      "v1": 9,
      "bias": -10,
      "bCoef": 0.1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "FF6666"
    },
    {
      "v0": 9,
      "v1": 8,
      "bias": 0,
      "bCoef": 0,
      "curve": 0,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "C5C5C5"
    },
    {
      "v0": 10,
      "v1": 11,
      "bias": 0,
      "bCoef": 0,
      "curve": 0,
      "vis": true,
      "cMask": [],
      "cGroup": [
        "wall"
      ],
      "color": "C5C5C5"
    },
    {
      "v0": 0,
      "v1": 1,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    },
    {
      "v0": 25,
      "v1": 10,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    },
    {
      "v0": 11,
      "v1": 26,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    },
    {
      "v0": 2,
      "v1": 3,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    },
    {
      "v0": 27,
      "v1": 8,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    },
    {
      "v0": 9,
      "v1": 24,
      "bias": -10,
      "bCoef": 1,
      "curve": 0,
      "vis": true,
      "cMask": [
        "ball"
      ],
      "cGroup": [
        "wall"
      ],
      "color": "ABC2D5"
    }
  ],
  "vertexes": [
    {
      "x": -401.4,
      "y": -200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 401.4,
      "y": -200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 401.4,
      "y": 200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -401.4,
      "y": 200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": 200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": -200,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": -80,
      "bCoef": 1,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "redKO",
        "blueKO"
      ]
    },
    {
      "x": 0,
      "y": 80,
      "bCoef": 1,
      "cMask": [
        "red",
        "blue"
      ],
      "cGroup": [
        "redKO",
        "blueKO"
      ]
    },
    {
      "x": -400,
      "y": 70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -400,
      "y": -70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": -70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": 70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": 230,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": -230,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 436.4,
      "y": -70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 436.4,
      "y": 70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -436.4,
      "y": -70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -436.4,
      "y": 70,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": -1.5,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 0,
      "y": 1.5,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": -135,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": 135,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -400,
      "y": -135,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -400,
      "y": 135,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -400,
      "y": -201.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": -201.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 400,
      "y": 201.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -400,
      "y": 201.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 435,
      "y": -71.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": 435,
      "y": 71.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -435,
      "y": -71.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    },
    {
      "x": -435,
      "y": 71.4,
      "bCoef": 1,
      "cMask": [],
      "cGroup": []
    }
  ],
  "goals": [
    {
      "p0": [
        -407.9,
        70
      ],
      "p1": [
        -407.9,
        -70
      ],
      "team": "red"
    },
    {
      "p0": [
        407.9,
        70
      ],
      "p1": [
        407.9,
        -70
      ],
      "team": "blue"
    }
  ],
  "planes": [
    {
      "normal": [
        0,
        1
      ],
      "dist": -230,
      "bCoef": 0,
      "cMask": [
        "all"
      ],
      "cGroup": [
        "wall"
      ]
    },
    {
      "normal": [
        0,
        -1
      ],
      "dist": -230,
      "bCoef": 0,
      "cMask": [
        "all"
      ],
      "cGroup": [
        "wall"
      ]
    },
    {
      "normal": [
        1,
        0
      ],
      "dist": -480,
      "bCoef": 0,
      "cMask": [
        "all"
      ],
      "cGroup": [
        "wall"
      ]
    },
    {
      "normal": [
        -1,
        0
      ],
      "dist": -480,
      "bCoef": 0,
      "cMask": [
        "all"
      ],
      "cGroup": [
        "wall"
      ]
    }
  ],
  "discs": [
    {
      "pos": [
        -400,
        -70
      ],
      "speed": [
        0,
        0
      ],
      "gravity": [
        0,
        0
      ],
      "radius": 5.4,
      "bCoef": 0.5,
      "invMass": 0,
      "damping": 0.99,
      "color": "31726",
      "cMask": [
        "all"
      ],
      "cGroup": [
        "all"
      ]
    },
    {
      "pos": [
        -400,
        70
      ],
      "speed": [
        0,
        0
      ],
      "gravity": [
        0,
        0
      ],
      "radius": 5.4,
      "bCoef": 0.5,
      "invMass": 0,
      "damping": 0.99,
      "color": "31726",
      "cMask": [
        "all"
      ],
      "cGroup": [
        "all"
      ]
    },
    {
      "pos": [
        400,
        -70
      ],
      "speed": [
        0,
        0
      ],
      "gravity": [
        0,
        0
      ],
      "radius": 5.4,
      "bCoef": 0.5,
      "invMass": 0,
      "damping": 0.99,
      "color": "31726",
      "cMask": [
        "all"
      ],
      "cGroup": [
        "all"
      ]
    },
    {
      "pos": [
        400,
        70
      ],
      "speed": [
        0,
        0
      ],
      "gravity": [
        0,
        0
      ],
      "radius": 5.4,
      "bCoef": 0.5,
      "invMass": 0,
      "damping": 0.99,
      "color": "31726",
      "cMask": [
        "all"
      ],
      "cGroup": [
        "all"
      ]
    }
  ],
  "joints": [],
  "ballPhysics": {
    "speed": [
      0,
      0
    ],
    "gravity": [
      0,
      0
    ],
    "radius": 5.8,
    "bCoef": 0.412,
    "invMass": 1.55,
    "damping": 0.99,
    "color": "FFF26D",
    "cMask": [
      "all"
    ],
    "cGroup": [
      "ball",
      "kick",
      "score"
    ]
  }
};
export default bffClassic;
